import React from "react";
import type { PlayerProfile } from "../../../../api/academyEnrolments/enrolmentsService";

interface PlayerSelectSectionProps {
  players: PlayerProfile[];
  selectedPlayer: PlayerProfile | null;
  onSelect: (p: PlayerProfile) => void;
  disabled?: boolean;
  registerBy: "self" | "parent" | "";
}

const PlayerSelectSection: React.FC<PlayerSelectSectionProps> = ({
  players,
  selectedPlayer,
  onSelect,
  disabled,
  registerBy: _registerBy,
}) => {
  return (
    <>
      {players.length === 0 ? (
        <p className="text-muted mb-0" style={{ fontSize: 13 }}>
          No matching profiles found for the selected registration type.
        </p>
      ) : (
        <div className="enrolment-player-list">
          {players.map((p) => (
            <div
              key={p._id}
              className={disabled ? "enrolment-readonly-field-wrapper" : undefined}
              style={disabled ? { display: "block" } : undefined}
            >
              <button
                type="button"
                className={`enrolment-player-card${selectedPlayer?._id === p._id ? " selected" : ""}${disabled ? " disabled" : ""}`}
                onClick={() => !disabled && onSelect(p)}
                disabled={disabled}
                style={disabled ? { pointerEvents: "none", width: "100%" } : undefined}
              >
                <div className="enrolment-player-avatar">
                  {p.profilePic ? (
                    <img src={p.profilePic} alt={p.fullName} />
                  ) : (
                    <span>{p.fullName?.charAt(0)?.toUpperCase() ?? "?"}</span>
                  )}
                </div>
                <div className="enrolment-player-info">
                  <span className="enrolment-player-name">{p.fullName}</span>
                  {p.dob && (
                    <span className="enrolment-player-meta text-muted">
                      DOB: {p.dob}
                    </span>
                  )}
                  {p.gender && (
                    <span className="enrolment-player-meta text-muted">
                      {p.gender}
                    </span>
                  )}
                </div>
                {selectedPlayer?._id === p._id && (
                  <i className="ri-checkbox-circle-fill text-primary ms-auto" />
                )}
              </button>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default PlayerSelectSection;
